export default {
  imagePadding: 15,
  imageRightMargin: 20,
};
